import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import PropTypes from "prop-types";
import MenuItem from "@mui/material/MenuItem";
import Icon from "@mui/material/Icon";

export function CustomMenuButton(props) {
  const { buttonTitle, items, onItemClicked, ...other } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const itemClicked = (item) => {
    console.log(item);
    onItemClicked(item.target.innerText);
    handleClose();
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {buttonTitle}
        <Icon fontSize="small" color={"text"}>
          {"more_vert"}
        </Icon>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        {items.map((item) => (
          <MenuItem onClick={(item) => itemClicked(item)} key={item.key}>
            <Icon fontSize="small" color={item.iconColor}>
              {item.icon}
            </Icon>
            {item.text}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

CustomMenuButton.propTypes = {
  items: PropTypes.array.isRequired,
  onItemClicked: PropTypes.func.isRequired,
  buttonTitle: PropTypes.string.isRequired,
};
